import { useEffect, useState } from 'react';

export function usePersistedState<T>(
    key: string,
    defaultValue: T
): [T, (value: T) => void] {
    // Initialize state from localStorage
    const [state, setState] = useState<T>(() => {
        const storedValue = localStorage.getItem(key);
        return storedValue !== null
            ? (JSON.parse(storedValue) as T)
            : defaultValue;
    });

    // Persist state changes to localStorage
    useEffect(() => {
        localStorage.setItem(key, JSON.stringify(state));
    }, [key, state]);

    return [state, setState];
}
